import { SEAGM_CATEGORY_LIST_ACTION } from "core/constants/Actions";
import { TypedThunk, TypedDispatch } from "App/Store";
import { getCategories } from "core/services/Category";

export function getSeagmCategoryList(params?: any): TypedThunk {
  return async (dispatch: TypedDispatch) => {
    dispatch({ type: SEAGM_CATEGORY_LIST_ACTION.REQUEST });
    const apiResponse = await getCategories(params);
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: SEAGM_CATEGORY_LIST_ACTION.SUCCESS,
        payload: {
          categories: apiResponse.data.categories,
          count: apiResponse.data.count,
        },
      });
    } else {
      dispatch({ type: SEAGM_CATEGORY_LIST_ACTION.FAILURE });
    }
  };
}
